import { fromJS, Map as iMap } from 'immutable';
import * as constants from './constants';

const initialState = iMap({
  // loaders:
  generatingReport: false,
  submittingSuggestion: false,

  selectedReport: 'progress',
  alloReport: 'detailed',
  blackoutReport: 'newContracts',
  startDate: '2019-04-01 00:00:00.000Z',
  endDate: '2020-03-31 00:00:00.000Z',
  suggestion: '',
  showSuggestionConfirmation: false,
  diff: {
    locationId: null,
    availDocs: [],
    rawDiffData: [],
    diffMetaData: {},
    ratesSummary: {},
  }
});

export function contractingReports(state = initialState, { type, payload }) {
  switch (type) {
    case constants.UPDATE_CREPORTS_PROP:
      return state.merge(fromJS(payload));
    case constants.SENDING_REPORT_SUGG:
      return state.set('submittingSuggestion', true);
    case constants.SENT_REPORT_SUGG:
      return state.set('submittingSuggestion', false)
                  .set('showSuggestionConfirmation', true);
    case `${constants.GET_CONTRACTING_DIFF_REPORT}_STARTED`:
      return state.set('generatingReport', true);
    case `${constants.GET_CONTRACTING_DIFF_REPORT}_SUCCESS`:
      return state.set('generatingReport', false)
      .update('diff', diff => Object.assign({}, diff, payload));
    case `${constants.GET_CONTRACTING_DIFF_REPORT}_ERROR`:
      return state.set('generatingReport', false);
    case 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS':
      return state.update('diff', diff => ({
        loadingDocs: true,
        ...diff,
        locationId: payload.locationId,
      }))
    case 'GET_AVAIL_DOCS_FOR_DIFF_REPORTS_SUCCESS':
      return state.update('diff', diff => ({
        ...diff,
        loadingDocs: false,
        availDocs: payload.contracts || payload.templates,
      }))
    case constants.CLEAR_STORE:
      return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/contracting-reports/reducer.js